import { defineStore } from 'pinia';
import { getMenuListForAll, getMenuListForUser } from '@/pages/layout/services';
import { transformList } from '@/utils';
import { flattenAndObject } from '@/utils/route-menu';
import lodash from 'lodash';

const storeKey = 'gattaran-workshop-store-menu';
const useMenuStore = defineStore(storeKey, {
  persist: [
    // 可以设置多个配置的
    {
      key: storeKey,
      storage: window.localStorage,
      // 优化 针对菜单的原始数据进行缓存处理
      // 注意 引用不会持久化。
      paths: ['originMenuListAll'],
      afterRestore: (ctx) => {
        console.log(`--> just restored '${ctx.store.$id}'`);
      },
    },
    // {
    //   key: storeKey,
    //   storage: window.sessionStorage,
    //   // 优化 针对菜单的原始数据进行缓存处理
    //   // 注意 引用不会持久化。
    //   paths: ['originMenuList', 'originMenuListAll'],
    //   afterRestore: (ctx) => {
    //     console.log(`--> just restored '${ctx.store.$id}'`);
    //   },
    // },
  ],
  state: () => {
    return {
      // 存储原始数据,服务端下发的数据
      originMenuList: [], // 有权限菜单的
      originMenuListAll: [], // 全量菜单数据

      // 路由菜单信息 转路由格式的，可以直接动态添加路由
      routeList: [], // 权限路由
      routeListAll: [], // 全量路由。
      // 路由打平
      routeFlattenObject: {}, // 权限路由打平
      routeAllFlattenObject: {}, // 全量路由打平
      // 当前菜单信息
      currentSideList: [], // 转换后的格式
    };
  },
  // getters有缓存功能
  getters: {
    getCurrentAsyncSideList: (state) => {
      return state.currentSideList?.filter((i) => i?.meta?.isAsync) || [];
    },
    // 筛选无权限菜单
    routeOmitFlattenObject(state) {
      return lodash.omit(state.routeAllFlattenObject, Object.keys(state.routeFlattenObject));
    },
    getRouteFlattenObject: (state) => state.routeFlattenObject,
    // 用户概述页数据查询
    getAllSideMenuMap: (state) => {
      return state.routeListAll.reduce((pre, next) => {
        if (!next.hidden) {
          pre[next.name] = next;
        }
        return pre;
      }, {});
    },
    // 根据nodeKey获取路由详细信息
    getRouteInfo: (state) => {
      return (nodeKey) => {
        if (!state.routeFlattenObject[nodeKey]) console.warn(`${nodeKey} not found!!`);
        return state.routeFlattenObject[nodeKey] || null;
      };
    },
  },
  actions: {
    getSideListByKey(key) {
      return this.routeList.find((i) => i.key === key)?.children();
    },
    /**
     * 初始化权限菜单相关数据
     * @returns {Promise<boolean>}
     */
    async initMenuList() {
      const next = (list) => {
        const newList = transformList(lodash.cloneDeep(list));
        this.routeList = newList;
        this.routeFlattenObject = flattenAndObject(newList);
      };
      try {
        const res = await getMenuListForUser();
        this.originMenuList = res;
        next(res);
        return true;
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * 初始化全量菜单相关数据
     * @returns {Promise<boolean>}
     */
    getMenuListAll() {
      const next = (list) => {
        const newList = transformList(lodash.cloneDeep(list));
        this.routeListAll = newList;
        this.routeAllFlattenObject = flattenAndObject(newList);
      };
      return getMenuListForAll()
        .then((res) => {
          this.originMenuListAll = res;
          next(res);
        })
        .catch((e) => {
          console.warn(e);
        });
    },
    async initCurrentSideList(key) {
      const allSideMenuMap = this.getAllSideMenuMap;
      const list = allSideMenuMap[key]?.children;
      if (Array.isArray(list)) {
        this.currentSideList = list;
      }
    },
    switchCountry() {
      this.originMenuList = [];
      this.originMenuListAll = [];
    },
  },
});
export default useMenuStore;
